import React from "react";
import styled from "styled-components";
import ReactModal from "react-modal";
import {ConstZIndex} from "../../../config/styles_const/styles_const";

ReactModal.setAppElement(`#root`);

interface IProps extends ReactModal.Props {
    className?: string;
}

const ReactModalAdapter: React.FC<IProps> = (props) => {
    const {className, ...rest} = props;

    const contentClassName = `${className}__content`;
    const overlayClassName = `${className}__overlay`;
    return (
        <ReactModal
            portalClassName={className}
            className={contentClassName}
            overlayClassName={overlayClassName}
            {...rest}
        />
    );
};

export const Modal = styled(ReactModalAdapter)`
  &__overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(29, 30, 31, 0.8);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: ${ConstZIndex.modal};
    opacity: 0;
    &.ReactModal__Overlay--after-open {
      opacity: 1;
    }
    &.ReactModal__Overlay--before-close {
      opacity: 0;
    }
  }

  &__content {
    position: fixed;
    //&.ReactModal__Content--after-open {
    //  …
    //}
    //&.ReactModal__Content--before-close {
    //  …
    //}
  }
`;

interface IModalWithStateProps {

}

interface IState {
    modalIsOpen: boolean;
}

export class ModalWithState extends React.Component<IModalWithStateProps, IState> {

    constructor(props: IModalWithStateProps) {
        super(props);
        this.state = {
            modalIsOpen: false
        };
    }

    public openModal = () => {
        this.setState({
            modalIsOpen: true,
        })
    };

    public closeModal = () => {
        this.setState({
            modalIsOpen: false,
        })
    };

    public render () {

        return (
            <React.Fragment>
                <button onClick={this.openModal}>open</button>
                <Modal
                    isOpen={this.state.modalIsOpen}
                    onRequestClose={this.closeModal}
                    contentLabel="Example"
                >
                    {this.props.children}
                </Modal>
            </React.Fragment>
        )
    }
}


// WEBPACK FOOTER //
// ./src/presentation/common/organism/modal.tsx